const toggleWatchlistOverlay = (state) => {
    const watchlistOverlay = document.getElementById('watchlistOverlay');

    if (watchlistOverlay) {
        if (state) {
            watchlistOverlay.classList.add('open');
        } else {
            watchlistOverlay.classList.remove('open');
        }
    }
};

const handleWatchlistBar = () => {
    const employersAnchorNav = document.querySelector('.jsEmployersAnchorNav');
    const watchlistContainer = document.getElementById('watchlistContainer');
    const watchlistNumber = document.getElementById('watchlistNumber');

    if (watchlistContainer) {
        const savedEmployers = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];

        if (savedEmployers.length > 0) {
            watchlistContainer.classList.remove('hidden');
            watchlistNumber.innerText = savedEmployers.length;

            if (employersAnchorNav) {
                employersAnchorNav.classList.remove('hidden');
            }
        } else {
            watchlistContainer.classList.add('hidden');

            if (employersAnchorNav) {
                employersAnchorNav.classList.add('hidden');
            }
        }
    }
};

const initWatchlist = () => {
    const openWatchlistButton = document.getElementById('openWatchlist');

    if (openWatchlistButton) {
        openWatchlistButton.addEventListener('click', () => toggleWatchlistOverlay(true));
        window.dispatchEvent(new Event('watchlist'));
    }

    handleWatchlistBar();

    window.addEventListener('watchlist', () => {
        handleWatchlistBar();
    }, false);
};

export default initWatchlist;
